import React, { useCallback, useEffect, useMemo, useState } from 'react';

import { Form, Input } from 'antd';
import { useForm } from 'antd/lib/form/Form';
import Modal from 'antd/lib/modal/Modal';

import { useAppDispatch, useAppSelector } from '@/Hooks/useAppRedux';

import { createLiteAppPost } from '@/Redux/slices/LiteAppSlice';

interface ModalProps {
  isModalVisible: boolean;
  setModalVisible: (visible: boolean) => void;
  postLength: number;
}

const CreateLiteAppPostModal = ({ isModalVisible, setModalVisible, postLength }: ModalProps) => {
  const dispatch = useAppDispatch();
  const { version } = useAppSelector((state) => state.liteApp.value);

  const [form] = useForm();
  const formValues = Form.useWatch([], form);
  const [submittable, setSubmittable] = useState(false);

  useEffect(() => {
    form
      .validateFields()
      .then(() => setSubmittable(true))
      .catch(() => setSubmittable(false));
  }, [form, formValues]);

  const onLiteAppPostCreate = () => {
    const payload = {
      uuid: formValues.postId,
      priority: postLength + 1,
    };

    form.resetFields();
    setModalVisible(false);
    dispatch(createLiteAppPost({ data: payload, version }));
  };

  const onModalClose = useCallback(() => {
    form.resetFields();
    setModalVisible(false);
  }, [form, setModalVisible]);

  return (
    <Modal
      title="Create Lite App post"
      open={isModalVisible}
      closable
      onCancel={onModalClose}
      okText="Create"
      onOk={onLiteAppPostCreate}
      okButtonProps={{ htmlType: 'submit', disabled: !submittable }}
    >
      <Form form={form} labelCol={{ span: 8 }} wrapperCol={{ span: 16 }}>
        <Form.Item
          name="postId"
          label="Post ID"
          rules={[
            {
              min: 1,
              required: true,
              message: 'Post ID cannot be empty',
            },
          ]}
        >
          <Input />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default CreateLiteAppPostModal;
